// web/src/components/PortfolioTriageTable.tsx

export interface PortfolioRow {
  account_id: string;
  display_name: string;
  spend: number;
  cpl: number | null;
  counts: {
    scale: number; throttle: number; refresh_creative: number; kill: number; open: number;
  };
}

export interface PortfolioTriageTableProps {
  accounts: PortfolioRow[];
  selectedAccountId: string | null;
  onSelect: (accountId: string) => void;
  windowDays: 7 | 14 | 30;
}

function fmtMoney(n: number): string {
  return "$" + Math.round(n).toLocaleString();
}

const COLS: Array<{ key: "scale" | "throttle" | "refresh_creative" | "kill"; label: string; color: string }> = [
  { key: "scale", label: "Scale", color: "#5fb37a" },
  { key: "throttle", label: "Throttle", color: "#d9a64a" },
  { key: "refresh_creative", label: "Refresh", color: "#5b9be8" },
  { key: "kill", label: "Kill", color: "#d96057" },
];

export function PortfolioTriageTable(props: PortfolioTriageTableProps) {
  return (
    <div>
      <div style={{ fontSize: 11, color: "#7a808c", textTransform: "uppercase", marginBottom: 8 }}>
        Portfolio triage — {props.accounts.length} end advertisers, {props.windowDays}d window
      </div>
      <table style={{ width: "100%", borderCollapse: "collapse", fontSize: 13, color: "#cdd3dc" }}>
        <thead>
          <tr style={{ color: "#7a808c", fontSize: 11, textTransform: "uppercase", textAlign: "left" }}>
            <th style={{ padding: "6px 8px" }}>End Advertiser</th>
            <th style={{ padding: "6px 8px", textAlign: "right" }}>{props.windowDays}d Spend</th>
            <th style={{ padding: "6px 8px", textAlign: "right" }}>CPL</th>
            {COLS.map((c) => (
              <th key={c.key} style={{ padding: "6px 8px", textAlign: "right" }}>{c.label}</th>
            ))}
            <th style={{ padding: "6px 8px", textAlign: "right" }}>Open</th>
          </tr>
        </thead>
        <tbody>
          {props.accounts.map((a) => {
            const selected = a.account_id === props.selectedAccountId;
            return (
              <tr
                key={a.account_id}
                onClick={() => props.onSelect(a.account_id)}
                style={{
                  cursor: "pointer",
                  background: selected ? "#1a1f2b" : "transparent",
                  opacity: a.counts.open === 0 ? 0.5 : 1,
                }}
              >
                <td style={{ padding: 8 }}>
                  <strong>{a.display_name}</strong>{" "}
                  <span style={{ color: "#7a808c" }}>· {a.account_id.slice(-8)}</span>
                </td>
                <td style={{ padding: 8, textAlign: "right" }}>{fmtMoney(a.spend)}</td>
                <td style={{ padding: 8, textAlign: "right" }}>
                  {a.cpl !== null ? fmtMoney(a.cpl) : "—"}
                </td>
                {COLS.map((c) => (
                  <td key={c.key} style={{ padding: 8, textAlign: "right", color: a.counts[c.key] > 0 ? c.color : "#7a808c" }}>
                    {a.counts[c.key]}
                  </td>
                ))}
                <td style={{ padding: 8, textAlign: "right", fontWeight: 600 }}>{a.counts.open}</td>
              </tr>
            );
          })}
        </tbody>
      </table>
    </div>
  );
}
